import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reload',
  template: '<div></div>'
})
export class LogoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
      // leave this component alone :D
      // we understand that this is not the correct way to solve this issue.
      // In order to solve some of the logout issues we created this component as a temporary landing page for the logout process.
  }

}
